(function(w){
	var sw = document.body.clientWidth,
		sh = document.body.clientHeight;

	jQuery(w).resize(function(){ //Update dimensions on resize
		sw = document.body.clientWidth;
		sh = document.body.clientHeight;
		
		//updateAds();
	});


	//Navigation toggle
	jQuery('.nav-toggle-menu').click(function(e) {
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery('.nav').toggleClass('active');
	});
	
	//Navigation toggle
	jQuery('.nav-toggle-search').click(function(e) {
		e.preventDefault();
		jQuery(this).toggleClass('active');
		jQuery('.header .search-form').toggleClass('active');
	});
})(this);